import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

import { Field } from "formik"

import { withRouter, Link, useHistory } from "react-router-dom"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// actions
import axios from "axios"
import Select from "react-select"

// import images
import profile from "assets/images/bridge-logo.png"
import bg from "assets/images/background1.jpg"
import toastr from "toastr"
import { TOAST_OPTIONS1, HRConfig2, HRConfig } from "helpers/backend_helper"
import { POST_LOGIN, EMPLOYEES, GET_COMPANY } from "helpers/apache_url"

const Login = props => {
  const history = useHistory()
  const [activeCompany, setCompany] = useState("")
  const [companyOptions, setCompanyOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  toastr.options = TOAST_OPTIONS1

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
      company: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
      company: Yup.string().required("Please Select Your Company"),
    }),
    onSubmit: values => {
      setIsLoading(true)
      axios
        .post(POST_LOGIN, JSON.stringify(values), HRConfig2)
        .then(function (response) {
          if (response.data.success == 1) {
            if (response.data.user.changePass == "Yes") {
              history.push("/change-password")
              toastr.info("Change Password")
            } else {
              // Check if user exists as staff
              localStorage.setItem(
                "authMildUser",
                JSON.stringify(response.data.user)
              )
              axios
                .get(
                  `${EMPLOYEES}?company=${response.data.user.activeCompany}&$filter=No eq '${response.data.user.uid}'`,
                  HRConfig
                )
                .then(function (res) {
                  if (res.data.value[0]) {
                    history.push("/dashboard")
                    toastr.success("Welcome, " + response.data.user.staffname)
                  } else {
                    localStorage.clear()
                    history.push("/login")
                    toastr.error("Employee does not exist in selected company!")
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            }
          } else {
            toastr.error(response.data.message)
          }
          setIsLoading(false)
        })
        .catch(function (error) {
          //toastr.error(error.response.data.error.message);
          console.log(error)
          setIsLoading(false)
        })
    },
  })

  const fetchData = () => {
    setIsLoading(true)
    axios
      .get(GET_COMPANY, HRConfig)
      .then(r => {
        let options = []
        r.data.map(e => {
          options.push({ label: `${e.companyName}`, value: e.companyName })
        })

        setCompanyOptions(options)
        setIsLoading(false)
      })
      .catch(e => {
        console.log(e)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | BRIDGE</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div
        className="account-pages my-0 pt-sm-5"
        style={{
          position: "absolute",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
          margin: 0,
          backgroundImage: "url(" + bg + ")",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className=" bg-soft">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary text-center p-4">
                        <img
                          src={profile}
                          alt=""
                          className="img-fluid"
                          height="80"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">E-mail</Label>
                        <Input
                          name="email"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className=" mb-3">
                        <Label htmlFor="company">Company</Label>
                        <Select
                          name="company"
                          id="company"
                          onBlur={() => {
                            validation.handleBlur({
                              target: { name: "company" },
                            })
                          }}
                          onChange={option => {
                            validation.setFieldValue("company", option.value)
                          }}
                          options={companyOptions}
                          invalid={
                            validation.touched.company &&
                            validation.errors.company
                              ? true
                              : false
                          }
                        />
                        {validation.touched.company &&
                        validation.errors.company ? (
                          <Alert color="danger">Please select a company</Alert>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        {isLoading ? (
                          <button
                            className="btn btn-warning btn-block"
                            type="button"
                          >
                            Please wait...
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Log In
                          </button>
                        )}
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                  <div className="mt-5 text-center">
                    <p>
                      Access jobs and careers:{" "}
                      <Link
                        to="/applicants-login"
                        className="fw-medium text-primary"
                      >
                        {" "}
                        E-Recruitment{" "}
                      </Link>{" "}
                    </p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
